<template>
  <div>
    <b-row>
      <b-col>
        <b-card no-body>
          <b-card-header>
            <b-card-title>The spacing system</b-card-title>
          </b-card-header>
          <b-card-body class="pb-1">
            <b-card-text>
              <b-row>
                <b-col cols="9">
                  The EasyParcel type stack specifies 14px for the base font size, which producs an 8 pixels x-height. The x-height is halved to produce a 4 pixels baseline.<br>
                  All spacing for components and typography is done in increment of 4 pixels baseline. This forms the basic unit of measurement for spacing.
                </b-col>
                <b-col cols="3">
                  <b-img
                    src="@/assets/images/pages/x-height-baseline.jpg"
                    fluid
                  />
                </b-col>
              </b-row>
            </b-card-text>
            <b-card-text>
              <b-row>
                <b-col cols="12">
                  This baseline convention naturally flows on to the rest of the spacing system, which includes icons, components, and layout dimensions.
                </b-col>
                <b-col cols="12">
                  <ul>
                    <li>Use multiples of 4px and at least 8px when defining measurements, spacing, and positioning elements.</li>
                    <li>When necessary use 4px to make more fine tuned adjustments.</li>
                    <li>Whenever possible, make sure that objects line up, both vertically and horizontally.</li>
                    <li>Line heights are set in increments of 4px and spacing is measured from the edges of the text boxes.</li>
                    <li>Align your bounding box to the grid, not the baseline of your text.</li>
                  </ul>
                </b-col>
              </b-row>
            </b-card-text>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow, BCol, BCard, BCardHeader, BCardTitle, BCardBody, BCardText, BImg,
} from 'bootstrap-vue'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BCardTitle,
    BCardText,
    BImg,
  },
}
</script>
